import React from "react";
import { Link } from "react-router-dom";
import SEO from "./SEO";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className="about-us">
      <SEO
        title="About Diviti Adora | Wellness Center Tucson Arizona | Oro Valley"
        description="Learn about Diviti Adora, your premier wellness sanctuary in Oro Valley offering infrared sauna, red light therapy, chromotherapy, and halotherapy services."
        keywords="wellness center Tucson Arizona, holistic healing Oro Valley, detox spa Marana, alternative wellness center Tucson, health and wellness studio Marana, mind body wellness Oro Valley, natural healing therapies Arizona, self-care spa Oro Valley, preventative health solutions Tucson, integrative health services Arizona"
        canonicalUrl="/about"
      />
      <div className="content-wrapper">
        <header>
          <h1>About Us</h1>
          <p>
            Welcome to Diviti Adora Infrared & Red Light Studio—your new
            favorite wellness sanctuary in the heart of Oro Valley.
          </p>
        </header>

        <section className="mission">
          <h2>Our Mission</h2>
          <p>
            Born from a passion for deep healing, inner radiance, and total body
            restoration, Diviti Adora exists to nurture your well-being on every
            level. Our name means Divine Love, a reflection of the intention,
            care, and holistic transformation that infuses everything we do.
          </p>
        </section>

        <section className="offerings">
          <h2>What We Offer</h2>
          <p>Inside our serene space, you'll discover:</p>
          <ul>
            <li>
              <strong>State-of-the-art infrared saunas</strong> that support
              detoxification, muscle recovery, and relaxation
            </li>
            <li>
              <strong>Medical-grade red light therapy</strong> designed to
              revitalize skin, improve cellular function, and promote healing
            </li>
            <li>
              <strong>Healing enhancements</strong> like Halotherapy to clear
              the airways and calm the mind
            </li>
          </ul>
        </section>

        <section className="philosophy">
          <h2>Our Philosophy</h2>
          <p>
            Whether you're seeking recovery, rejuvenation, or simply a peaceful
            pause in your day, we're here to support your wellness journey—mind,
            body, and soul.
          </p>
          <div className="quote">
            <p>At Diviti Adora, this isn't just self-care.</p>
            <p>It's soul care.</p>
          </div>
          <p className="tagline">Let's radiate together.</p>
        </section>

        <section className="cta">
          <Link to="/book-session" className="cta-button">
            Book Your Session
          </Link>
          <Link to="/memberships" className="cta-button secondary">
            Explore Memberships
          </Link>
        </section>

        <footer>
          <p>
            &copy; {new Date().getFullYear()} Diviti Adora, LLC. All rights
            reserved.
          </p>
          <p>
            <Link to="/">Back to Home</Link>
          </p>
        </footer>
      </div>
    </div>
  );
};

export default AboutUs;
